module.exports = __webpack_public_path__ + "static/media/profestional-business-agency.dc2c4671.png";